<template>
  <div class="image-list" data-ios-emulate-scroll="x">
    <button class="item picker" v-on:click="pickFile">
      <div style="font-size: 175%">
        <i class="fas fa-cloud-upload-alt"></i>
      </div>
      <div style="font-size: 75%; line-height: 1.5; margin-bottom: -5px">
        {{ I18n.t("upload_background") }}
      </div>
    </button>
    <button
      v-if="pixabayEnabled"
      class="item picker"
      v-on:click="openSearchBackgroundOverlay"
      style="background-image: url('/images/search-background/search_background_tile_bg.jpg')"
    >
      <div style="font-size: 175%">
        <i class="fas fa-search" style="text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)"></i>
      </div>
      <div style="font-size: 75%; line-height: 1.5; margin-bottom: -5px; text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)">
        {{ I18n.t("search_background") }}
      </div>
    </button>
    <button
      v-bind:key="image.image_url"
      v-bind:class="{ item: true, active: value == image }"
      v-for="image in images"
      v-bind:style="{ 'background-image': `url('${image.thumbnail_url}')` }"
      v-on:click="select(image)"
    >
      <div
        class="foreground-thumbnail"
        v-bind:style="{ 'background-image': foregroundUrl ? `url('${foregroundUrl}')` : '' }"
        data-hj-suppress
      ></div>
    </button>
  </div>
</template>

<script>
import $ from "jquery";
import { rbgEditorUploadBackgroundImageV100, rbgEditorApplyBackgroundImageV101 } from "kaleido-event-tracker";
import Rails from "@rails/ujs";
import loadSuggestions from "../src/image_suggestions";
import loadPixabaySuggestions from "../src/image_suggestions_pixabay";
import Flipper from "@/modules/flipper";

export default {
  props: {
    resultId: String,
    foregroundType: String,
    value: String,
    foregroundUrl: String,
    locale: String,
  },
  data() {
    return {
      images: [],
      pixabayEnabled: false,
      pixabayImages: null,
      fileInput: null,
    };
  },
  mounted() {
    loadSuggestions(this.foregroundType).then((images) => {
      this.images = images;
    });

    this.pixabayEnabled = Flipper.isEnabled("pixabay");
    if (this.pixabayEnabled == true) {
      loadPixabaySuggestions(this.foregroundType).then((images) => {
        // load in parallel
        this.pixabayImages = images;
        this.$emit("setPixabayImages", images);
      });
    }
  },
  methods: {
    select: function (image) {
      window.track("Editor", "set_bg_suggestion", "Set Background Suggestion");
      rbgEditorApplyBackgroundImageV101({ image_id: this.resultId, background_image_id: image.image_url });
      this.$emit("change", { newValue: image.image_url });
      $.ajax({
        // the purpose of this request is to count how often this background is picked
        type: "POST",
        headers: {
          "X-CSRF-Token": Rails.csrfToken(),
        },
        url: image.download_location,
      });
    },
    pickFile() {
      if (this.fileInput) this.fileInput.remove();
      this.fileInput = $(`
        <input type="file" accept=".jpg,.jpeg,.png,image/jpeg,image/png" style="position: absolute; left: -9999px; top: -9999px;" />
      `);
      this.fileInput.appendTo($("body"));
      this.fileInput[0].click();
      $(this.fileInput).on("change", (e) => {
        var files = e.target.files;
        if (files.length == 0) return;

        window.track("Editor", "set_bg_file", "Set Background File");

        var file = files[0];
        var url = window.URL || window.webkitURL;
        var src = url.createObjectURL(file);

        rbgEditorUploadBackgroundImageV100({ image_id: this.resultId });

        this.$emit("change", { newValue: src });
        // TODO: url.revokeObjectURL(src);
      });
    },
    openSearchBackgroundOverlay() {
      this.$emit("openSearchBackgroundOverlay", this.pixabayImages);
    },
  },
};
</script>

<style scoped>
.image-list {
  padding: 0;
  margin: 0;
  margin-left: -10px;
  margin-right: -10px;
  display: -webkit-flex;
  display: flex;
  overflow: auto;
}
.image-list .item {
  margin: 0 10px;
  width: 80px;
  height: 80px;
  border: #6f6f6f;
  flex: 0 0 auto;
  outline: none;
  border: 1px solid #6f6f6f;
  position: relative;
  background-position: center;
  background-size: cover;
}
.image-list .item + .item {
  margin-left: 0;
}
.image-list .item.active {
  border-color: #fff;
}
.picker {
  background: #6f6f70;
  color: #fff;
  line-height: 1;
  font-weight: 400;
}
.image-list .item .foreground-thumbnail {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

@media (min-width: 768px) {
  .image-list {
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
  }
  .image-list .item {
    margin: 0 5px 10px 5px;
  }
  .image-list .item.active {
  }
  .image-list .item + .item {
    margin-left: 5px;
  }
}

.image-list {
  padding-bottom: 12px;
}
</style>
